import type { FormatDateOptions } from '@atlassian/jira-intl';

export const DEFAULT_FORMAT_DATE_OPTIONS: FormatDateOptions = {
	day: '2-digit',
	month: 'short',
	year: 'numeric',
};
